<template>
    <div ref="blogComponent" class="blog-wrapper" v-show="isLoad || items?.length">
        <div class="container">
            <div class="blog-wrapper__title-container">
                <h2 class="blog-wrapper__title-container__content">{{ $t('blogTitle') }}</h2>
                <svg class="blog-wrapper__title-container__icon">
                    <use :xlink:href="iconLink('arrowRightIcon')" />
                </svg>
            </div>

            <div v-if="items?.length > 0" class="blog-wrapper__card-container">
                <NuxtLink
                    v-for="(item, index) in filteredItems"
                    :to="localePath(item.url)"
                    :key="index + item.title"
                    class="blog-wrapper__item"
                >
                    <div class="blog-wrapper__item__image-container">
                        <img class="blog-wrapper__item__image-container__image" :src="item.img" :alt="item.title" />
                    </div>

                    <span class="blog-wrapper__item__title">{{ item.title }}</span>
                    <hr style="text-align: justify" />
                    <time class="blog-wrapper__item__date" :datetime="item.date">{{ handledDate(item.date) }}</time>
                </NuxtLink>
            </div>

            <div v-else class="blog-wrapper__card-container">
                <div v-for="i in 4" :key="i" class="blog-wrapper__item">
                    <MySkeleton class="blog-wrapper__item__skeleton-img" />
                    <MySkeleton class="blog-wrapper__item__skeleton-title" />
                    <MySkeleton class="blog-wrapper__item__skeleton-date" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { BlogItem, createBlogItem } from './types';
import VueTypes from 'vue-types';
import { formatDateDDMonth } from '@/themes/novaporta/utils/time';

export default {
    name: 'BlogComponent',
    components: {
        MySkeleton: () => import('@/themes/novaporta/components/ui/MySkeleton')
    },
    // props: {
    //     items: VueTypes.arrayOf(BlogItem).def(() => [])
    // },
    data() {
        return {
            items: [],
            isLoad: true
        };
    },
    computed: {
        filteredItems() {
            return this.items.slice(0, 4);
        }
    },
    methods: {
        handledDate(date) {
            return formatDateDDMonth(date, this);
        },
        iconLink(icon) {
            const spritePath = require('@/themes/novaporta/assets/icons/sprite.svg');
            return `${spritePath}#${icon}`;
        },
        async fetchBlogItems() {
            this.isLoad = true;
            try {
                const { data } = await this.$api.article.getArticle('top');

                this.items = [...data.new, ...data.popular].map(item => {
                    return createBlogItem({
                        title: item.title,
                        img: item.img,
                        date: item.publishDate,
                        url: `/articles/${item.url}`
                    });
                });
            } catch (error) {
                console.error('Failed to fetch articles:', error);
            }
            this.isLoad = false;
        }
    },
    async fetch() {
        await this.fetchBlogItems();
    }
};
</script>
<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
